export enum INDENT_DIRECTION {
  INDENT = 1,
  UNINDENT = -1,
}

export enum INLINE_DIRECTION {
  FORWARDS = 1,
  BACKWARDS = -1,
}

export enum SORT_ORDER {
  ASCENDING = 1,
  DESCENDING = -1,
}
